import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { AMAZON_URL, BOOK } from "@/data/book";

const links = [
  { href: "#about", label: "The Book", id: "nav-link-about" },
  { href: "#poems", label: "Poems", id: "nav-link-poems" },
  { href: "#themes", label: "Themes", id: "nav-link-themes" },
  { href: "#author", label: "Author", id: "nav-link-author" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#fdfbf7]/85 backdrop-blur-xl border-b border-stone-200/70 shadow-[0_1px_20px_rgba(32,28,25,0.04)]"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-6xl mx-auto px-6 h-[72px] flex items-center justify-between">
        <a
          href="#top"
          data-testid="navbar-logo-link"
          className="font-display text-xl sm:text-2xl tracking-tight text-[#201c19] hover:text-[#2a7b76] transition-colors"
        >
          {BOOK.title}
        </a>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.id}
              className="text-sm font-medium text-[#4b443e] hover:text-[#2a7b76] transition-colors tracking-wide"
            >
              {l.label}
            </a>
          ))}
          <a
            href={AMAZON_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-buy-amazon-btn"
            className="rounded-full bg-[#201c19] text-[#fdfbf7] text-sm font-semibold px-5 py-2.5 hover:bg-[#2a7b76] transition-colors duration-300"
          >
            Buy on Amazon
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[#201c19] p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-[#fdfbf7]/95 backdrop-blur-xl border-t border-stone-200/70 px-6 py-5 flex flex-col gap-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`${l.id}-mobile`}
              onClick={() => setOpen(false)}
              className="text-base font-medium text-[#4b443e] hover:text-[#2a7b76]"
            >
              {l.label}
            </a>
          ))}
          <a
            href={AMAZON_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}
            className="rounded-full bg-[#201c19] text-[#fdfbf7] text-center text-sm font-semibold px-5 py-3 mt-1"
          >
            Buy on Amazon
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
